import IntegrationsContainer from './IntegrationsContainer';
export default IntegrationsContainer;
